import { Box, IconButton } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const ToggleFullScreen = ({ setIsFullscreen, isFullscreen }) => {
  const toggleFullscreen = () => {
    const gridElement = document.getElementById("grid-container");
    if (!document.fullscreenElement) {
      gridElement.requestFullscreen().then((r) => {
        setIsFullscreen(true);
      });
    } else {
      document.exitFullscreen().then((r) => {
        setIsFullscreen(false);
      });
    }
  };

  return (
    <Box style={{ display: "flex", justifyContent: "flex-end" }}>
      <IconButton
        onClick={() => {
          toggleFullscreen();
        }}
        color="inherit"
      >
        {isFullscreen ? <FullscreenIcon /> : <FullscreenExitIcon />}
      </IconButton>
    </Box>
  );
};

export default ToggleFullScreen;
